export default {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
}
